import CityPageTemplate from "../city-template/CityPageTemplate";
import { ellicottCityConfig } from "./data";

export default function EllicottCityPage() {
  return <CityPageTemplate config={ellicottCityConfig} />;
}